var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._t("default",null,{"isLoading":_vm.isLoading,"campaign":_vm.campaign,"incompleteProposal":_vm.incompleteProposal,"isCreatingProposal":_vm.isCreatingProposal,"createProposal":_vm.handleProposalCreate})],2)}
var staticRenderFns = []

export { render, staticRenderFns }